import React from 'react';
import { CollapseProps } from 'antd';

import {
  StyledAntdCollapse,
} from './style';

// type CollapseProps = typeof Collapse.propTypes

const CVCollapse = (props: React.PropsWithChildren<CollapseProps>): JSX.Element => (
  <StyledAntdCollapse {...props} />
);

CVCollapse.Panel = StyledAntdCollapse.Panel;

export default CVCollapse;
